const countries = [
  { code: "US", label: "United States", region: "North America" },
  { code: "CA", label: "Canada",        region: "North America" },

  // Meksika + Orta Amerika
  { code: "MX", label: "Mexico",              region: "Latin America" },
  { code: "GT", label: "Guatemala",           region: "Latin America" },
  { code: "HN", label: "Honduras",            region: "Latin America" },
  { code: "SV", label: "El Salvador",         region: "Latin America" },
  { code: "NI", label: "Nicaragua",           region: "Latin America" },
  { code: "CR", label: "Costa Rica",          region: "Latin America" },
  { code: "PA", label: "Panama",              region: "Latin America" },

  // Karayipler
  { code: "AG", label: "Antigua and Barbuda", region: "Latin America" },
  { code: "AI", label: "Anguilla",            region: "Latin America" },
  { code: "AW", label: "Aruba",               region: "Latin America" },
  { code: "BB", label: "Barbados",            region: "Latin America" },
  { code: "BL", label: "Saint Barthélemy",    region: "Latin America" },
  { code: "BM", label: "Bermuda",             region: "Latin America" },
  { code: "BS", label: "Bahamas",             region: "Latin America" },
  { code: "BZ", label: "Belize",              region: "Latin America" },
  { code: "CU", label: "Cuba",                region: "Latin America" },
  { code: "DM", label: "Dominica",            region: "Latin America" },
  { code: "DO", label: "Dominican Republic",  region: "Latin America" },
  { code: "GD", label: "Grenada",             region: "Latin America" },
  { code: "GL", label: "Greenland",           region: "Latin America" },
  { code: "GP", label: "Guadeloupe",          region: "Latin America" },
  { code: "HT", label: "Haiti",               region: "Latin America" },
  { code: "JM", label: "Jamaica",             region: "Latin America" },
  { code: "KN", label: "Saint Kitts and Nevis",region: "Latin America" },
  { code: "KY", label: "Cayman Islands",      region: "Latin America" },
  { code: "LC", label: "Saint Lucia",         region: "Latin America" },
  { code: "MF", label: "Saint-Martin",        region: "Latin America" },
  { code: "MQ", label: "Martinique",          region: "Latin America" },
  { code: "MS", label: "Montserrat",          region: "Latin America" },
  { code: "PM", label: "Saint Pierre and Miquelon", region: "Latin America" },
  { code: "PR", label: "Puerto Rico",         region: "Latin America" },
  { code: "SX", label: "Sint Maarten",        region: "Latin America" },
  { code: "TC", label: "Turks and Caicos Islands", region: "Latin America" },
  { code: "TT", label: "Trinidad and Tobago", region: "Latin America" },
  { code: "VC", label: "Saint Vincent and the Grenadines", region: "Latin America" },
  { code: "VG", label: "British Virgin Islands", region: "Latin America" },
  { code: "VI", label: "U.S. Virgin Islands", region: "Latin America" },

  // Güney Amerika
  { code: "AR", label: "Argentina",  region: "Latin America" },
  { code: "BO", label: "Bolivia",    region: "Latin America" },
  { code: "BR", label: "Brazil",     region: "Latin America" },
  { code: "CL", label: "Chile",      region: "Latin America" },
  { code: "CO", label: "Colombia",   region: "Latin America" },
  { code: "EC", label: "Ecuador",    region: "Latin America" },
  { code: "FK", label: "Falkland Islands", region: "Latin America" },
  { code: "GF", label: "French Guiana",     region: "Latin America" },
  { code: "GY", label: "Guyana",     region: "Latin America" },
  { code: "PE", label: "Peru",       region: "Latin America" },
  { code: "PY", label: "Paraguay",   region: "Latin America" },
  { code: "SR", label: "Suriname",   region: "Latin America" },
  { code: "UY", label: "Uruguay",    region: "Latin America" },
  { code: "VE", label: "Venezuela",  region: "Latin America" },

  { code: "AL", label: "Albania", region: "Europe" },
  { code: "AD", label: "Andorra", region: "Europe" },
  { code: "AT", label: "Austria", region: "Europe" },
  { code: "AX", label: "Åland Islands", region: "Europe" },
  { code: "BA", label: "Bosnia and Herzegovina", region: "Europe" },
  { code: "BE", label: "Belgium", region: "Europe" },
  { code: "BG", label: "Bulgaria", region: "Europe" },
  { code: "BY", label: "Belarus", region: "Europe" },       // CIS
  { code: "CH", label: "Switzerland", region: "Europe" },
  { code: "CY", label: "Cyprus", region: "Europe" },
  { code: "CZ", label: "Czech Republic", region: "Europe" },
  { code: "DE", label: "Germany", region: "Europe" },
  { code: "DK", label: "Denmark", region: "Europe" },
  { code: "EE", label: "Estonia", region: "Europe" },
  { code: "ES", label: "Spain", region: "Europe" },
  { code: "FI", label: "Finland", region: "Europe" },
  { code: "FO", label: "Faroe Islands", region: "Europe" },
  { code: "FR", label: "France", region: "Europe" },
  { code: "GB", label: "United Kingdom", region: "Europe" },
  { code: "GG", label: "Guernsey", region: "Europe" },
  { code: "GI", label: "Gibraltar", region: "Europe" },
  { code: "GR", label: "Greece", region: "Europe" },
  { code: "HR", label: "Croatia", region: "Europe" },
  { code: "HU", label: "Hungary", region: "Europe" },
  { code: "IE", label: "Ireland", region: "Europe" },
  { code: "IM", label: "Isle of Man", region: "Europe" },
  { code: "IS", label: "Iceland", region: "Europe" },
  { code: "IT", label: "Italy", region: "Europe" },
  { code: "JE", label: "Jersey", region: "Europe" },
  { code: "LI", label: "Liechtenstein", region: "Europe" },
  { code: "LT", label: "Lithuania", region: "Europe" },
  { code: "LU", label: "Luxembourg", region: "Europe" },
  { code: "LV", label: "Latvia", region: "Europe" },
  { code: "MC", label: "Monaco", region: "Europe" },
  { code: "MD", label: "Moldova", region: "Europe" },
  { code: "ME", label: "Montenegro", region: "Europe" },
  { code: "MK", label: "North Macedonia", region: "Europe" },
  { code: "MT", label: "Malta", region: "Europe" },
  { code: "NL", label: "Netherlands", region: "Europe" },
  { code: "NO", label: "Norway", region: "Europe" },
  { code: "PL", label: "Poland", region: "Europe" },
  { code: "PT", label: "Portugal", region: "Europe" },
  { code: "RO", label: "Romania", region: "Europe" },
  { code: "RS", label: "Serbia", region: "Europe" },
  { code: "RU", label: "Russia", region: "Europe" },        // CIS
  { code: "SE", label: "Sweden", region: "Europe" },
  { code: "SI", label: "Slovenia", region: "Europe" },
  { code: "SJ", label: "Svalbard and Jan Mayen", region: "Europe" },
  { code: "SK", label: "Slovakia", region: "Europe" },
  { code: "SM", label: "San Marino", region: "Europe" },
  { code: "TR", label: "Türkiye", region: "Europe" },
  { code: "UA", label: "Ukraine", region: "Europe" },
  { code: "VA", label: "Vatican City", region: "Europe" },

  // Asya (MENA ve CIS ülkeleri hariç)
  { code: "AF", label: "Afghanistan", region: "Asia-Pacific (APAC)" },
  { code: "BD", label: "Bangladesh", region: "Asia-Pacific (APAC)" },
  { code: "BN", label: "Brunei",     region: "Asia-Pacific (APAC)" },
  { code: "BT", label: "Bhutan",     region: "Asia-Pacific (APAC)" },
  { code: "CC", label: "Cocos (Keeling) Islands", region: "Asia-Pacific (APAC)" },
  { code: "CN", label: "China",            region: "Asia-Pacific (APAC)" },
  { code: "CX", label: "Christmas Island", region: "Asia-Pacific (APAC)" },
  { code: "HK", label: "Hong Kong",        region: "Asia-Pacific (APAC)" },
  { code: "ID", label: "Indonesia",        region: "Asia-Pacific (APAC)" },
  { code: "IL", label: "Israel",           region: "Asia-Pacific (APAC)" },
  { code: "IN", label: "India",            region: "Asia-Pacific (APAC)" },
  { code: "JP", label: "Japan",            region: "Asia-Pacific (APAC)" },
  { code: "KH", label: "Cambodia",         region: "Asia-Pacific (APAC)" },
  { code: "KP", label: "North Korea",      region: "Asia-Pacific (APAC)" },
  { code: "KR", label: "South Korea",      region: "Asia-Pacific (APAC)" },
  { code: "LA", label: "Laos",             region: "Asia-Pacific (APAC)" },
  { code: "LK", label: "Sri Lanka",        region: "Asia-Pacific (APAC)" },
  { code: "MM", label: "Myanmar",          region: "Asia-Pacific (APAC)" },
  { code: "MN", label: "Mongolia",         region: "Asia-Pacific (APAC)" },
  { code: "MO", label: "Macao",            region: "Asia-Pacific (APAC)" },
  { code: "MY", label: "Malaysia",         region: "Asia-Pacific (APAC)" },
  { code: "NP", label: "Nepal",            region: "Asia-Pacific (APAC)" },
  { code: "PH", label: "Philippines",      region: "Asia-Pacific (APAC)" },
  { code: "PK", label: "Pakistan",         region: "Asia-Pacific (APAC)" },
  { code: "SG", label: "Singapore",        region: "Asia-Pacific (APAC)" },
  { code: "TH", label: "Thailand",         region: "Asia-Pacific (APAC)" },
  { code: "TL", label: "Timor-Leste",      region: "Asia-Pacific (APAC)" },
  { code: "TW", label: "Taiwan",           region: "Asia-Pacific (APAC)" },
  { code: "VN", label: "Vietnam",          region: "Asia-Pacific (APAC)" },
  { code: "YE", label: "Yemen",            region: "Asia-Pacific (APAC)" }, // MENA değil

  // Okyanusya
  { code: "AS", label: "American Samoa",        region: "Asia-Pacific (APAC)" },
  { code: "AU", label: "Australia",             region: "Asia-Pacific (APAC)" },
  { code: "CK", label: "Cook Islands",          region: "Asia-Pacific (APAC)" },
  { code: "FJ", label: "Fiji",                  region: "Asia-Pacific (APAC)" },
  { code: "FM", label: "Micronesia",            region: "Asia-Pacific (APAC)" },
  { code: "GU", label: "Guam",                  region: "Asia-Pacific (APAC)" },
  { code: "HM", label: "Heard Island and McDonald Islands", region: "Asia-Pacific (APAC)" },
  { code: "KI", label: "Kiribati",              region: "Asia-Pacific (APAC)" },
  { code: "MH", label: "Marshall Islands",      region: "Asia-Pacific (APAC)" },
  { code: "MP", label: "Northern Mariana Islands", region: "Asia-Pacific (APAC)" },
  { code: "NC", label: "New Caledonia",         region: "Asia-Pacific (APAC)" },
  { code: "NF", label: "Norfolk Island",        region: "Asia-Pacific (APAC)" },
  { code: "NR", label: "Nauru",                 region: "Asia-Pacific (APAC)" },
  { code: "NU", label: "Niue",                  region: "Asia-Pacific (APAC)" },
  { code: "NZ", label: "New Zealand",           region: "Asia-Pacific (APAC)" },
  { code: "PG", label: "Papua New Guinea",      region: "Asia-Pacific (APAC)" },
  { code: "PN", label: "Pitcairn Islands",      region: "Asia-Pacific (APAC)" },
  { code: "PW", label: "Palau",                 region: "Asia-Pacific (APAC)" },
  { code: "SB", label: "Solomon Islands",       region: "Asia-Pacific (APAC)" },
  { code: "TK", label: "Tokelau",               region: "Asia-Pacific (APAC)" },
  { code: "TO", label: "Tonga",                 region: "Asia-Pacific (APAC)" },
  { code: "TV", label: "Tuvalu",                region: "Asia-Pacific (APAC)" },
  { code: "UM", label: "US Minor Outlying Islands", region: "Asia-Pacific (APAC)" },
  { code: "VU", label: "Vanuatu",               region: "Asia-Pacific (APAC)" },
  { code: "WF", label: "Wallis and Futuna",     region: "Asia-Pacific (APAC)" },
  { code: "DZ", label: "Algeria",        region: "Middle East & North Africa (MENA)" },
  { code: "EG", label: "Egypt",          region: "Middle East & North Africa (MENA)" },
  { code: "LY", label: "Libya",          region: "Middle East & North Africa (MENA)" },
  { code: "MA", label: "Morocco",        region: "Middle East & North Africa (MENA)" },
  { code: "SD", label: "Sudan",          region: "Middle East & North Africa (MENA)" },
  { code: "TN", label: "Tunisia",        region: "Middle East & North Africa (MENA)" },
  { code: "AE", label: "United Arab Emirates", region: "Middle East & North Africa (MENA)" },
  { code: "BH", label: "Bahrain",        region: "Middle East & North Africa (MENA)" },
  { code: "IQ", label: "Iraq",           region: "Middle East & North Africa (MENA)" },
  { code: "IR", label: "Iran",           region: "Middle East & North Africa (MENA)" },
  { code: "JO", label: "Jordan",         region: "Middle East & North Africa (MENA)" },
  { code: "KW", label: "Kuwait",         region: "Middle East & North Africa (MENA)" },
  { code: "LB", label: "Lebanon",        region: "Middle East & North Africa (MENA)" },
  { code: "OM", label: "Oman",           region: "Middle East & North Africa (MENA)" },
  { code: "PS", label: "Palestine",      region: "Middle East & North Africa (MENA)" },
  { code: "QA", label: "Qatar",          region: "Middle East & North Africa (MENA)" },
  { code: "SA", label: "Saudi Arabia",   region: "Middle East & North Africa (MENA)" },
  { code: "SY", label: "Syria",          region: "Middle East & North Africa (MENA)" },

  // Afrika listemizden MENA ülkeleri çıkarıldı
  { code: "AO", label: "Angola",        region: "Sub-Saharan Africa" },
  { code: "BF", label: "Burkina Faso",  region: "Sub-Saharan Africa" },
  { code: "BI", label: "Burundi",       region: "Sub-Saharan Africa" },
  { code: "BJ", label: "Benin",         region: "Sub-Saharan Africa" },
  { code: "BW", label: "Botswana",      region: "Sub-Saharan Africa" },
  { code: "CD", label: "Congo (Kinshasa)", region: "Sub-Saharan Africa" },
  { code: "CF", label: "Central African Republic", region: "Sub-Saharan Africa" },
  { code: "CG", label: "Congo (Brazzaville)", region: "Sub-Saharan Africa" },
  { code: "CI", label: "Côte d'Ivoire", region: "Sub-Saharan Africa" },
  { code: "CM", label: "Cameroon",      region: "Sub-Saharan Africa" },
  { code: "CV", label: "Cabo Verde",    region: "Sub-Saharan Africa" },
  { code: "DJ", label: "Djibouti",      region: "Sub-Saharan Africa" },
  { code: "ER", label: "Eritrea",       region: "Sub-Saharan Africa" },
  { code: "ET", label: "Ethiopia",      region: "Sub-Saharan Africa" },
  { code: "GA", label: "Gabon",         region: "Sub-Saharan Africa" },
  { code: "GH", label: "Ghana",         region: "Sub-Saharan Africa" },
  { code: "GM", label: "Gambia",        region: "Sub-Saharan Africa" },
  { code: "GN", label: "Guinea",        region: "Sub-Saharan Africa" },
  { code: "GQ", label: "Equatorial Guinea", region: "Sub-Saharan Africa" },
  { code: "GW", label: "Guinea-Bissau", region: "Sub-Saharan Africa" },
  { code: "KE", label: "Kenya",         region: "Sub-Saharan Africa" },
  { code: "KM", label: "Comoros",       region: "Sub-Saharan Africa" },
  { code: "LR", label: "Liberia",       region: "Sub-Saharan Africa" },
  { code: "LS", label: "Lesotho",       region: "Sub-Saharan Africa" },
  { code: "MG", label: "Madagascar",    region: "Sub-Saharan Africa" },
  { code: "ML", label: "Mali",          region: "Sub-Saharan Africa" },
  { code: "MR", label: "Mauritania",    region: "Sub-Saharan Africa" },
  { code: "MU", label: "Mauritius",     region: "Sub-Saharan Africa" },
  { code: "MW", label: "Malawi",        region: "Sub-Saharan Africa" },
  { code: "MZ", label: "Mozambique",    region: "Sub-Saharan Africa" },
  { code: "NA", label: "Namibia",       region: "Sub-Saharan Africa" },
  { code: "NE", label: "Niger",         region: "Sub-Saharan Africa" },
  { code: "NG", label: "Nigeria",       region: "Sub-Saharan Africa" },
  { code: "RE", label: "Réunion",       region: "Sub-Saharan Africa" },
  { code: "RW", label: "Rwanda",        region: "Sub-Saharan Africa" },
  { code: "SC", label: "Seychelles",    region: "Sub-Saharan Africa" },
  { code: "SH", label: "Saint Helena",  region: "Sub-Saharan Africa" },
  { code: "SL", label: "Sierra Leone",  region: "Sub-Saharan Africa" },
  { code: "SN", label: "Senegal",       region: "Sub-Saharan Africa" },
  { code: "SO", label: "Somalia",       region: "Sub-Saharan Africa" },
  { code: "SS", label: "South Sudan",   region: "Sub-Saharan Africa" },
  { code: "ST", label: "São Tomé and Príncipe", region: "Sub-Saharan Africa" },
  { code: "SZ", label: "Eswatini",      region: "Sub-Saharan Africa" },
  { code: "TD", label: "Chad",          region: "Sub-Saharan Africa" },
  { code: "TG", label: "Togo",          region: "Sub-Saharan Africa" },
  { code: "TZ", label: "Tanzania",      region: "Sub-Saharan Africa" },
  { code: "UG", label: "Uganda",        region: "Sub-Saharan Africa" },
  { code: "YT", label: "Mayotte",       region: "Sub-Saharan Africa" },
  { code: "ZM", label: "Zambia",        region: "Sub-Saharan Africa" },
  { code: "ZW", label: "Zimbabwe",      region: "Sub-Saharan Africa" },
  { code: "AZ", label: "Azerbaijan",   region: "CIS & Central Asia" },
  { code: "AM", label: "Armenia",      region: "CIS & Central Asia" },
  { code: "GE", label: "Georgia",      region: "CIS & Central Asia" },
  { code: "KZ", label: "Kazakhstan",   region: "CIS & Central Asia" },
  { code: "KG", label: "Kyrgyzstan",   region: "CIS & Central Asia" },
  { code: "TJ", label: "Tajikistan",   region: "CIS & Central Asia" },
  { code: "TM", label: "Turkmenistan", region: "CIS & Central Asia" },
  { code: "UZ", label: "Uzbekistan",   region: "CIS & Central Asia" },

];

// Bayrak URL'sini dinamik olarak oluşturuyoruz
const countryOptions = countries.map((country) => ({
  ...country,
  flagUrl: `https://flagcdn.com/w40/${country.code.toLowerCase()}.png`,
}));

export default countryOptions;
